<template>
  <BaseListItem>
    <div class="flex -mx-3 p-4">
      <div class="flex-1 px-3 capitalize">
        <RouterLink :to="to">
          {{ pipeline.name }}
        </RouterLink>
      </div>
      <div class="flex-1 px-3 text-right">
        {{ pipeline.contactRequestsCount || 0 }}
      </div>
      <div class="w-48 px-3 text-right">
        <p>
          {{ pipeline.createdAtDiffForHumans }}
        </p>
        <p class="text-sm text-gray-600">
          {{ pipeline.createdAt }}
        </p>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
export default {
  props: {
    pipeline: {
      type: Object,
      required: true,
    },
  },
  computed: {
    to() {
      const { id: pipelineUuid } = this.pipeline;
      const { accountId } = this.$route.params;

      return {
        name: 'accounts.pipelines.pipelineUuid',
        params: { accountId, pipelineUuid },
      };
    },
  },
};
</script>
